import { withViewComponent } from '@updater-legacy/components/custom-element';
import '@updater-components/icon';
import '@updater-components/cta';
import styles from './errors.css';

class ErrorsPage extends withViewComponent(styles)() {
  handleRetry = () => {
    this.dispatchEvent(
      new CustomEvent('upd-error-page-events', {
        detail: {
          retry: true,
        },
      })
    );
  };

  handleDashboard = () =>
    this.dispatchEvent(
      new CustomEvent('upd-error-page-events', {
        detail: {
          retry: false,
        },
      })
    );

  connected() {
    this.render`
      <upd-fa-icon 
        id="icon" 
        name="exclamation-triangle" 
        type="solid"
      >
      </upd-fa-icon>
      <h1>Something went wrong</h1>
      <p class="error-message">Hit Retry below or go back to the dashboard to complete your other moving related tasks.</p>
      <upd-cta primary>
        <button 
          onclick=${this.handleRetry}
        >
          Retry
        </button>
      </upd-cta>
      <a   
        class="error-link"
        onclick=${this.handleDashboard}
      >
        Back to dashboard
      </a>
    `;
  }
}

customElements.define('upd-error-page', ErrorsPage);
